import { IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {EventEmitter, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {Subject} from 'rxjs';
import {take} from 'rxjs/operators';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {CommandService} from '@core/services/command.service';
import {DialogService} from '@shared/services/dialog-service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {FileManagementService} from '@core/services/file-management.service';
import {Api} from '@shared/constants/common-field.constants';

@Injectable({
  providedIn: 'root',
})
export class WebsiteUsageReportHandler implements IPlatformToolHandler {
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  magicLinkModel: MagicLinkModel;
  selectedTabModel: TabModel;
  ngUnsubscribe = new Subject<void>();
  invalidateSubject: InvalidateSubject;

  constructor(private commandService: CommandService,
              private router: Router,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService
  ) {
  }

  executeCommand(command: PlatformCommand) {
    console.log('[usage-report-platform-command] onPlatformTool Handler Command', command);
    switch (command.name) {
      case 'DateFilterCommand':
        this.invalidateUsageReportView(command);
        break;
      default:
        this.executeCommandToApi(command);
        break;
    }
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('[usage-report-platform-command] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand'] as PlatformCommand);
          }
          if (commandResponse.fieldValues['ErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['SnackBarMessage']);
          }

          if (commandResponse.fieldValues['FileId']) {
            const fileId = commandResponse.fieldValues['FileId'];
            const fileName = commandResponse.fieldValues['FileName'];

            this.downloadFile(fileId, fileName);
          }

          this.invalidateSubject.invalidate();
        },
        error => {
          this.fuseSplashScreenService.hide();
        });
    }
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
    if (this.handleByFieldDefinition($event)) {
      return;
    }
    // if ($event.item && $event.fieldDefinition && $event.fieldSection) {
    //   switch ($event.fieldSection.id) {
    //     case 'translation':
    //       return;
    //     case 'activityfilter':
    //       this.router.navigateByUrl(`activities/filter/${$event.item.id}`);
    //       return;
    //   }
    // }
  }

  private handleCommand($event): boolean {
    if ($event.command) {
      switch ($event.command.name) {
        case 'CreateFilterCommand':
          this.crateFilter($event.command);
          return true;
        default:
          this.executeCommand($event.command);
          return true;
      }
    }
    return false;
  }

  private handleAction($event): boolean {
    // if (this.selectedTabModel && $event.action) {
    //   switch ($event.action.id) {
    //     case 'Open':
    //       this.router.navigateByUrl(`activities/filter/${$event.item.id}`);
    //       return true;
    //     case 'Delete':
    //       this.deleteActivityFilter($event);
    //       return true;
    //     case 'Share':
    //       this.shareActivityFilter($event);
    //       return true;
    //     case 'Archive':
    //       this.toggleArchiveActivityFilter($event, true);
    //       return true;
    //     case 'Unarchive':
    //       this.toggleArchiveActivityFilter($event, false);
    //       return true;
    //     case 'AttachTask':
    //       this.attachToTask($event);
    //       return true;
    //     case 'TaskClosed':
    //       this.updateTaskStatus($event);
    //       return true;
    //     case 'Edit':
    //       this.openEditor($event);
    //       return true;
    //   }
    // }
    return false;
  }

  private handleByFieldDefinition($event): boolean {
    if (this.selectedTabModel && $event.fieldDefinition) {
      switch ($event.fieldDefinition.key) {
        case 'ArticleTitle':
          this.router.navigateByUrl(`administration/usage-report/orbitax-website/by-article/${$event.item.cells['ArticleTitle'].value}`);
          return true;
        case 'UserCountByFeature':
          this.router.navigateByUrl(`administration/usage-report/orbitax-website/by-feature/${$event.item.id}`);
          return true;
        case 'UserCountByCompany':
          this.router.navigateByUrl(`administration/usage-report/orbitax-website/by-company/${$event.item.id}`);
          return true;
      }
    }
    return false;
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }

  destroy() {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private openEditor($event: any) {

  }

  private crateFilter(command: PlatformCommand) {
    console.log('crate filter:', command);
    this.executeCommandToApi(command);
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }

  private invalidateUsageReportView(command: PlatformCommand) {
    const updateViewCommand = new PlatformCommand('CreateUsageReportLinkCommand', Api.TaxHubApi);

    updateViewCommand.fieldValues['UsagePeriod'] = command.fieldValues['UsagePeriod'];
    updateViewCommand.fieldValues['IncrementPeriod'] = command.fieldValues['IncrementPeriod'] ;
    updateViewCommand.fieldValues['StartDate'] = command.fieldValues['StartDate'] ;
    updateViewCommand.fieldValues['EndDate'] = command.fieldValues['EndDate'] ;
    updateViewCommand.fieldValues['SelectedTabId'] = this.selectedTabModel.id;

    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(updateViewCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
        if (response.fieldValues['PlatformLinkModel']) {

          this.magicLinkModel = response.fieldValues['PlatformLinkModel'];
          this.selectedTabModel = this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex];

          this.magicLinkModelValueChangedHandler({id: 'PlatformToolContainerComponent', value: response.fieldValues['PlatformLinkModel'],
            magicLinkModel: this.magicLinkModel, selectedTab: this.selectedTabModel});

          this.magicLinkModelValueChangedHandler({id: 'PlatformToolVirtualGridComponent', value: response.fieldValues['PlatformLinkModel'],
            magicLinkModel: this.magicLinkModel, selectedTab: this.selectedTabModel});

          this.invalidateSubject.invalidate();
        } else {
          console.log('Platform link model not found');
          this.fuseSplashScreenService.hide();
        }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Operation failed!!!', error);
      });
  }

  private downloadFile(fileId: string, fileName: string) {
    this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
      this.fileManagementService.openSaveFileWindow(payload, fileName);
      this.fuseSplashScreenService.hide();
    });
  }
}
